module.exports = __webpack_public_path__ + "img/sClaFruit7_193x205.b204e946.png";